import { addProduct } from './addProduct';
import { ADD_TO_BASKET_EVENT } from '../events/addToBasketEvent';

/**
 * Initialises all basket-related event listeners.
 */
export function initialiseBasketListeners(): void {
	// Listener for adding a product to the basket
	document.addEventListener(ADD_TO_BASKET_EVENT, (event) => {
		const button = event.detail.targetElement.shadowRoot?.querySelector(
			'.wc-product__atb-btn, .wc-case__atb-btn',
		) as HTMLButtonElement;

		if (!button || !(button instanceof HTMLButtonElement)) {
			console.error('Event target is not a button');
			return;
		}

		const { productId, productName, productType, quantity, isPersonalized, depositPrice } =
			event.detail;

		// Call the addProduct function based on the product type
		addProduct(
			button,
			productId,
			productName,
			productType,
			Number(quantity),
			isPersonalized,
			depositPrice ?? null,
		);
	});

	// Global event listeners for the AddToBasket popup
	const atbPopUp = document.getElementById('add-to-basket-popup');
	const closeButtons = document.querySelectorAll<HTMLElement>('.add-to-basket-popup-close');

	if (!atbPopUp) {
		// We are probably in a webview on the app
		return;
	}

	atbPopUp.addEventListener('mouseover', () => {
		atbPopUp.classList.add('hovering');
	});

	atbPopUp.addEventListener('mouseleave', () => {
		atbPopUp.classList.remove('hovering');
	});

	closeButtons.forEach((button) => {
		button.addEventListener('click', (e) => {
			e.preventDefault();
			const atbWrapper = document.getElementById('add-to-basket-popup-wrapper');
			if (atbWrapper) {
				atbWrapper.classList.remove('active');
			}
		});
	});
}
